import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthService } from '@journal/core/api/auth/auth.service';
import { JournalService } from '@journal/core/api/journal/journal.service';
import { SearchService } from '@journal/core/api/search/search.service';
import { UserService } from '@journal/core/api/user/user.service';
import { CompetitionService } from '@journal/core/api/competition/competition.service';
// import { CookieService } from 'ngx-cookie-service';

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [
    JournalService,
    AuthService,
    UserService,
    SearchService,
    CompetitionService
  ]
})
export class CoreModule { }
